import airplaneIcon from '@/assets/svg/airplane.svg'
import { LangText, SagawaDeliveryPoints } from '@/components'

const DeliveryServices = () => (
  <section className="mx-auto w-[1200px] pt-[60px]">
    <div className="flex flex-col items-center">
      <LangText
        lngKey="sagawa.delivery.title"
        className="text-[36px] font-bold leading-[50px] text-[#000]"
      />
      <span className="mt-[20px] h-[4px] w-[108px] rounded-full bg-primary" />
      <div className="mt-[48px] flex items-center gap-[12px]">
        <img src={airplaneIcon} alt="" className="size-[35px]" />
        <LangText
          lngKey="sagawa.delivery.airportToHotel"
          className="text-[30px] font-bold leading-[42px] text-primary"
        />
      </div>
    </div>
    <SagawaDeliveryPoints className="mt-[48px]" />
  </section>
)

export default DeliveryServices
